import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { Form } from 'react-bootstrap-5';
import EmptyState from 'shared/empty_state';

class SelectedItems extends React.Component {
  static propTypes = {
    itemLabel: PropTypes.string,
    items: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired,

    onDeselect: PropTypes.func.isRequired
  }

  handleDeselect = (event) => {
    const item = this.props.items[parseInt(event.currentTarget.dataset.index)];
    this.props.onDeselect(item);
  }

  render() {
    return (
      <div className="d-flex" style={{ height: '200px' }}>
        {this.props.items.length === 0 ? this.renderEmptyItems() : this.renderItems()}
      </div>
    );
  }

  renderEmptyItems() {
    return (
      <EmptyState bodyText={`No ${this.props.itemLabel || 'items'} selected`} className="w-100" />
    );
  }

  renderItems() {
    return (
      <div className="d-flex flex-fill flex-column w-100">
        <Form.Label>Selected {this.props.itemLabel}</Form.Label>
        <div className="bg-light border rounded flex-fill overflow-auto">
          <ul className="list-group">
            {this.props.items.map((item, i) => this.renderItem(item, i))}
          </ul>
        </div>
      </div>
    );
  }

  renderItem(item, i) {
    return (
      <li className="list-group-item" key={i}>
        <span className="text-truncate flex-grow-1">
          {this.props.renderItem(item)}
        </span>

        <FontAwesomeIcon
          className="text-danger ms-auto clickable"
          data-index={i}
          icon={faTimes}
          name="deselect"
          onClick={this.handleDeselect}
        />
      </li>
    );
  }
}

export default SelectedItems;
